import React from 'react';
import { Section } from './Section';
import { CheckCircle2, FileText, Smartphone, Clock, Users } from 'lucide-react';
import { CTAButton } from './CTAButton';
const deliverables = [{
  icon: Smartphone,
  title: 'The Full Phone-First Ebook',
  desc: 'Quick to read, deep enough to use. Designed for one-handed reading.'
}, {
  icon: FileText,
  title: 'One-Page Day Map',
  desc: 'Save it to your camera roll for instant reference.'
}, {
  icon: CheckCircle2,
  title: '7-Day Progress Tracker',
  desc: 'See your progress even when the days feel messy.'
}, {
  icon: Clock,
  title: '20-Minute Rescue Protocol',
  desc: 'A step-by-step plan for the 3pm spiral.'
}, {
  icon: Users,
  title: 'Partner One-Pager',
  desc: "Stop explaining everything while you're exhausted."
}];
export function WhatYouGet() {
  return <Section alternate className="relative overflow-hidden" data-id="element-164">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/linen.png')] opacity-30 pointer-events-none" data-id="element-165"></div>

      <div className="text-center mb-12 relative z-10" data-id="element-166">
        <h2 className="font-serif text-3xl md:text-4xl text-brown mb-4" data-id="element-167">
          What's Inside The Reset
        </h2>
        <p className="text-brown-light" data-id="element-168">Immediate download. PDF format.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12 relative z-10" data-id="element-169">
        {deliverables.map((item, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm flex flex-col items-center text-center md:items-start md:text-left" data-id="element-170">
            <item.icon className="w-8 h-8 text-sage mb-4" data-id="element-171" />
            <h3 className="font-serif text-lg font-bold text-brown mb-2" data-id="element-172">
              {item.title}
            </h3>
            <p className="text-sm text-brown-light" data-id="element-173">{item.desc}</p>
          </div>)}
      </div>

      <div className="bg-terracotta/5 p-8 rounded-2xl text-center max-w-2xl mx-auto mb-12 relative z-10 border border-terracotta/10" data-id="element-174">
        <h3 className="font-serif text-2xl text-brown mb-4" data-id="element-175">
          Why it's priced at{' '}
          <span className="line-through opacity-50 text-lg" data-id="element-176">$19.97</span>{' '}
          <span className="text-terracotta font-bold" data-id="element-177">$6.39</span>
        </h3>
        <p className="text-brown-light mb-0" data-id="element-178">
          Because you're not buying information. You're buying{' '}
          <strong data-id="element-179">a plan you can use today</strong> — for less than a café stop.
        </p>
      </div>

      <div className="flex justify-center relative z-10" data-id="element-180">
        <CTAButton text="Download Now" price="$6.39" originalPrice="$19.97" discountLabel="68% OFF" className="w-full md:w-auto min-w-[300px]" data-id="element-181" />
      </div>
    </Section>;
}